import css from 'styled-jsx/css';
import { icons, typography } from '../../../config/styles';
import colors from '../../../config/styles/colors';
import { svgToDataUri } from '../../../utils/styles/svgMixins';

const AvailabilityMobileStyles = css`
  .availability {
    width: 100%;
    &-container {
      display: flex;
      padding-bottom: 12px;
      flex-direction: column;
      align-items: flex-start;
      .availability-item {
        display: flex;
        flex-direction: row;
        align-items: flex-start;
        gap: 8px;
        height: auto;
        width: 100%;
        margin: 0;
        box-sizing: border-box;
        border-top: 1px solid ${colors.gray.shade3};
        padding: 12px 0 12px 0;
        &.title {
          span.softline-title {
            padding-top: 5px;
          }
          span {
            width: 100%;
            text-align: left;
            font-weight: 700;
            font-size: 14px;
            padding-top: 10px;
            padding-bottom: 10px;
          }
        }
        .icon {
          background-repeat: no-repeat;
          background-size: contain;
          background-position: center;
        }
        &.rebranded {
          .deliveryAvailable {
            background-image: url('${svgToDataUri(icons.homeDeliveryMint)}');
            height: 24px;
            width: 24px;
            flex-shrink: 0;
          }
          .whitelabel-deliveryAvailable {
            background-image: url('${svgToDataUri(icons.whitelabel_homeDeliveryMint)}');
            height: 24px;
            width: 24px;
            flex-shrink: 0;
          }
          .siteToStoreAvailable {
            background-image: url('${svgToDataUri(icons.buyInStoreIconRebranded)}');
          }
          .pickupInStoreAvailable {
            background-image: url('${svgToDataUri(icons.pickUpInStoreMint)}');
            height: 24px;
            width: 24px;
            flex-shrink: 0;
          }
          .whitelabel-pickupInStoreAvailable {
            background-image: url('${svgToDataUri(icons.whitelabel_pickUpInStoreMint)}');
            height: 24px;
            width: 24px;
            flex-shrink: 0;
          }
          .see-stores {
            height: 24px;
            width: 24px;
            flex-shrink: 0;
            background-image: url('${svgToDataUri(icons.stockInStoreMint)}');
          }
          .downloadAvailable {
            background-image: url('${svgToDataUri(icons.downloadIconRebranded)}');
            height: 24px;
            width: 24px;
            flex-shrink: 0;
          }
          .purchaseOnlineAvailable {
            background-image: url('${svgToDataUri(icons.purchaseOnlineAvailableIconRebranded)}');
          }
        }
        &.rebranded::after {
          content: '';
          display: inline-block;
          margin-left: auto; /* empuja la flecha al final */
          background-image: url('${svgToDataUri(icons.arrowRight)}');
          width: 19px;
          height: 20px;
          flex-shrink: 0;
          background-repeat: no-repeat;
          background-size: contain;
          background-position: center;
        }
        &.lastItem {
          border-bottom: 1px solid ${colors.gray.shade3};
        }
        .content {
          height: auto;
          width: 100%;
          justify-content: center;
          align-items: flex-start;
          color: #333;
          font-size: 14px;
          font-style: normal;
          font-weight: 700;
          line-height: 20px;
          &.outofstock {
            display: block;
            .no-delivery {
              font-size: 14px;
              font-style: normal;
              font-weight: 700;
              line-height: 20px;
              color: ${colors.gray.shade52};
            }
            .no-delivery-comuna {
              color: #717171;
              font-size: 12px;
              font-style: normal;
              font-weight: 400;
              line-height: 16px;
            }
          }
          &-main {
            display: flex;
            flex-direction: column;
            .bold {
              font-weight: bold;
            }
            &.outofstock {
              color: ${colors.gray.shade44};
            }
          }
          &-sub {
            cursor: pointer;
            color: ${colors.gray.shade40};
            width: 100%;
            div {
              outline: none;
              display: inline;
              span {
                &.caret > i {
                  padding-left: 6px;
                  display: inline-block;
                  font-size: ${typography.xxs};
                }
              }
            }
          }
          .placeholder-text {
            color: ${colors.gray.shade44};
            font-size: 12px;
            letter-spacing: 0;
            line-height: 21px;
            span {
              font-weight: bold;
            }
          }
          &.downloadAvailable {
            border-radius: 4px;
            font-size: 14px;
            font-style: normal;
            font-weight: 400;
            line-height: 20px;
          }
        }
      }
    }
  }
`;

export { AvailabilityMobileStyles };
